/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Actual_Computed_SetpointInputs */



/**
* | output |
* | --- |
* | "Current computed setpoint" |
*
* @param {Air_Handler_Unit_Actual_Computed_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_actual_computed_setpoint = /** @type {((inputs?: Air_Handler_Unit_Actual_Computed_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Actual_Computed_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Current computed setpoint")
	return /** @type {LocalizedString} */ ("Consigne calculée actuelle")
});